"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.titlePropertyDefinition = void 0;
exports.titlePropertyDefinition = {
    view: {
        label: 'Title',
        style: 'h1',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'maxLength',
            argument: 50,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'title',
};
const isTitleProperty = (prop) => {
    return prop.name === exports.titlePropertyDefinition.name;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGl0bGUucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy90aXRsZS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHVCQUF1QixHQUFHO0lBQ3JDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxPQUFPO1FBQ2QsS0FBSyxFQUFFLElBQUk7S0FDWjtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFdBQVc7WUFDakIsUUFBUSxFQUFFLEVBQUU7U0FDYjtLQUNGO0lBQ0QsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxPQUFPO0NBQ2tCLENBQUE7QUFJakMsTUFBTSxlQUFlLEdBQUcsQ0FBQyxJQUFrQixFQUF5QixFQUFFO0lBQ3BFLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywrQkFBdUIsQ0FBQyxJQUFJLENBQUE7QUFDbkQsQ0FBQyxDQUFBIn0=